import {Component} from '@angular/core';

@Component({
  selector: 'app-welcome-skeleton',
  standalone: true,
  host: {class: 'flex flex-1 min-h-0 flex-col'},
  template: `
    <div class="flex min-h-full flex-1 flex-col" role="status" aria-label="Loading welcome page" aria-busy="true">
      <div aria-hidden="true" class="flex flex-1 flex-col">
        <div class="flex justify-center mt-fdk-m">
          <div class="skeleton w-[232px] max-w-full h-[72px]"></div>
        </div>
        <div class="mt-fdk-l space-y-2">
          <div class="skeleton h-6 w-full"></div>
          <div class="skeleton h-6 w-full"></div>
          <div class="skeleton h-6 w-2/3 mx-auto"></div>
        </div>
        <div class="mt-fdk-m space-y-2">
          <div class="skeleton h-5 w-16"></div>
          <div class="skeleton h-4 w-full"></div>
          <div class="skeleton h-4 w-5/6"></div>
        </div>
        <div class="mt-fdk-m space-y-2">
          <div class="skeleton h-5 w-20"></div>
          <div class="skeleton h-4 w-full"></div>
          <div class="skeleton h-4 w-5/6"></div>
        </div>
        <div class="mt-auto pt-6 space-y-6">
          <div class="space-y-2">
            <div class="skeleton h-3 w-full"></div>
            <div class="skeleton h-3 w-full"></div>
            <div class="skeleton h-3 w-2/3"></div>
          </div>
          <div class="skeleton h-12 w-full"></div>
        </div>
      </div>
      <span class="sr-only">Loading welcome page</span>
    </div>
  `,
})
export class WelcomeSkeletonComponent {}
